import { computed, onMounted } from 'vue';

interface UsePaginationOptions {
	/**
	 * Name of the query parameter holding the current page number.
	 * @example
	 * /us/guide?page=5
	 */
	queryParam?: string;

	/** Number of the last page with content. */
	lastPage?: number;
}

export const parsePageNumber = (page: string) => (Number.isNaN(page) ? 1 : Math.max(1, +page));

/** Get page information from the route on pages using Pagination. */
export function usePagination({ queryParam = 'page', lastPage }: UsePaginationOptions = {}) {
	const route = useRoute();
	const pageQuery = computed(() => route.query?.[queryParam]);

	// handle navigation to negative page numbers or non "Number" pages
	onMounted(() => {
		const router = useRouter();
		const pageOutOfBounds = lastPage && currentPage.value > lastPage;
		const negativeOrInvalidPage =
			pageQuery.value != null && (Number.isNaN(+pageQuery.value) || +pageQuery.value < 1);

		if (pageOutOfBounds || negativeOrInvalidPage) {
			// Router throws a navigation cancelled error which is expected
			router.replace({ query: {} }).catch(() => {});
		}
	});

	const currentPage = computed(() => (Number.isNaN(+pageQuery.value) ? 1 : Math.max(1, +pageQuery.value)));

	const isFirstPage = computed(() => currentPage.value === 1 || currentPage.value === 0);

	return {
		currentPage,
		isFirstPage,
		parsePageNumber,
	};
}
